import React, { useEffect, useState } from "react";
// import RMSPortfolioSyncContainer from 'containers/JarvisRMS/RMSPortfolioSync'
import RMSAddPortfolioContainer from "containers/JarvisRMS/RMSAddPortfolio";
import { useDispatch, useSelector } from "react-redux";
import AssessmentModal from "components/Assessment/AssessmentModal";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { masterActions } from "stores/master/masterActions";

const PortfolioSync = () => {
  const [openModal, setOpenModal] = useState(false);

  const getCurrentStage = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.currentStage
  );

  const isPaymentCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isPaymentCompleted
  );

  const dispatch = useDispatch();

  const onboardingStages = [
    {
      stageId: ["RISK_ASSESSMENT"],
      stageNumber: 1,
    },
    {
      stageId: ["SYNC_PORTFOLIO"],
      stageNumber: 2,
    },
    {
      stageId: ["CKYC", "DOCUMENT_SIGNING"],
      stageNumber: 3,
    },
  ];

  const getActiveStage = () => {
    return onboardingStages.find((o) => o.stageId.includes(getCurrentStage));
  };

  const activeStage = getActiveStage();

  useEffect(() => {
    if (activeStage.stageNumber >= 1) {
      setOpenModal(true);
    }
  }, [isPaymentCompleted]);

  const handleClose = () => setOpenModal(false);

  const handleConfirm = () => {
    setOpenModal(false);
    dispatch(
      jarvsiRMSOnboardingActions.updateRMSOnboardingData({
        currentStage: "RISK_ASSESSMENT",
      })
    );
    dispatch(masterActions.getFirstRender(false));

    // window.location.reload();
  };

  return (
    <>
      <RMSAddPortfolioContainer processType="INITIAL" />
      {!isPaymentCompleted && (
        <AssessmentModal
          open={openModal}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default PortfolioSync;
